import {Page} from "@mvvm/Page";

export class FormStep extends Page {
    async validateAndSubmit(): Promise<boolean> {
        return true;
    }
}